module.exports = __webpack_public_path__ + "img/page-17.51f27bf5.jpg";